/**
 * Composant Breadcrumb
 * Auto-activation du dernier élément
 */

import { logger } from '../../core/base.js';

export function initBreadcrumb() {
    document.querySelectorAll('nav.ui-breadcrumb').forEach(breadcrumb => {
        breadcrumb.querySelector('li:last-child').classList.add('is-active');
    });

    logger.debug('Breadcrumb initialized');
}

document.addEventListener('DOMContentLoaded', initBreadcrumb);
